<div class="page">
  @if (mission) {
    <app-section-toolbar
      [sectionTitle]="'MISSION.SUPPORT' | translate"
      [isComplete]="isSupportComplete()"
      [addLabel]="'UI.ADD.SUPPORT_MEMBER' | translate"
      (back)="backToMissionConfig()"
      (toggleStatus)="toggleSupportStatus()"
      (add)="openTeamModal()">
    </app-section-toolbar>
  }

  <section class="card">
    <div class="card__header">
      <div class="card__title">
        <ng-icon name="heroLifebuoy" size="20"/>
        {{ 'UI.REMOTE_SUPERVISION' | translate }}
        <span class="count-badge">{{ missionSupportTeams?.length ?? 0 }}</span>
      </div>
    </div>
    @if (missionSupportTeams?.length) {
      <table class="data-table">
        <thead>
          <tr>
            <th>{{ 'TEAM.TEAM_MEMBER' | translate }}</th>
            <th>{{ 'TEAM.LOCATION' | translate }}</th>
            <th>{{ 'TEAM.LAST_UPDATE' | translate }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (team of missionSupportTeams; track team) {
            <tr>
              <td class="cell-strong">{{ team.teamMemberFirstName }} {{ team.teamMemberName }}</td>
              <td>{{ team.peoplelocationname }}</td>
              <td class="cell-muted">{{ team.lastUpdatedOn | timestampToDate | async }} · {{ team.lastUpdatedBy }}</td>
              <td class="cell-actions">
                @if (!isSupportComplete()) {
                  <button type="button" class="icon-action danger" [title]="'DELETE' | translate" (click)="removeTeam(team)">
                    <ng-icon name="heroTrash" size="18"/>
                  </button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <div class="empty-state">
        <ng-icon name="heroLifebuoy" size="32"/>
        <div class="empty-state__title">{{ 'UI.EMPTY.SUPPORT' | translate }}</div>
        <div class="empty-state__text">{{ 'UI.EMPTY.SUPPORT_TEXT' | translate }}</div>
      </div>
    }
  </section>

  @if (runIteamTeams?.length) {
    <section class="card">
      <div class="card__header">
        <div class="card__title">
          <ng-icon name="heroUsers" size="20"/>
          {{ 'UI.RUN_ITEAM' | translate }}
          <span class="count-badge">{{ runIteamTeams.length }}</span>
        </div>
        <span class="cell-muted">{{ 'UI.ASSIGNED_AUTOMATICALLY' | translate }}</span>
      </div>
      <table class="data-table">
        <tbody>
          @for (team of runIteamTeams; track team) {
            <tr>
              <td class="cell-strong">{{ team.teamMemberFirstName }} {{ team.teamMemberName }}</td>
              <td>{{ team.peoplelocationname }}</td>
            </tr>
          }
        </tbody>
      </table>
    </section>
  }
</div>

@if (addingTeam) {
  <app-add-team
    [missionTeams]="missionSupportTeams"
    [rolename]="rolename"
    [defaultMarket]="mission.marketname"
    (closeModal)="closeTeamModal($event)"
    (addTeam)="addTeam($event)">
  </app-add-team>
}
